<template>
  <div class="light-gray-container">
    <div class="row white-container">
      <!-- col 1 -->
      <div class="col-12 col-md pb-3 pb-md-0">
        <template v-if="isOneStudent">
          <div class="row">
            <div class="col-1">
              <i class="orange-icon fal fa-address-book" />
            </div>
            <div class="col-10 d-flex flex-column">
              <label>Número de PEI:</label>
              <span>{{ formatPeiNumber(information.peiId) }}</span>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="row">
            <div class="col-1">
              <i class="orange-icon fal fa-flag" />
            </div>
            <div class="col-10 d-flex flex-column">
              <label>Estatus:</label>
              <span>
                {{ getRequestStatus }}
              </span>
            </div>
          </div>
        </template>
      </div>

      <template v-if="!isOneStudent">
        <div class="col-12 col-md pb-3 pb-md-0">
          <div class="row">
            <div class="col-1">
              <i class="orange-icon fal fa-clipboard-list-check" />
            </div>
            <div class="col-10 d-flex flex-column">
              <label>Número de Solicitud:</label>
              <span>{{ getRequestNumber }}</span>
            </div>
          </div>
        </div>
      </template>

      <!-- col 2 -->
      <div class="col-12 col-md pb-3 pb-md-0">
        <template v-if="isOneStudent">
          <div class="row">
            <div class="col-1">
              <i class="orange-icon fal fa-flag" />
            </div>
            <div class="col-10 d-flex flex-column">
              <label>Estatus:</label>
              <span>
                {{ getRequestStatus }}
              </span>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="row">
            <div class="col-1">
              <i class="orange-icon fas fa-map" />
            </div>
            <div class="col-10 d-flex flex-column">
              <label>Región:</label>
              <span class="text-capitalize">
                {{
                  information.regionName
                    ? information.regionName.toLowerCase()
                    : ""
                }}
              </span>
            </div>
          </div>
        </template>
      </div>

      <template v-if="isOneStudent">
        <div class="col-12 col-md pb-3 pb-md-0">
          <div class="row">
            <div class="col-1">
              <i class="orange-icon fal fa-clipboard-list-check" />
            </div>
            <div class="col-10 d-flex flex-column">
              <label>Número de Solicitud:</label>
              <span>{{ getRequestNumber }}</span>
            </div>
          </div>
        </div>
      </template>

      <!-- col 3 -->
      <div class="col-12 col-md pb-3 pb-md-0">
        <template v-if="isOneStudent">
          <div class="row">
            <div class="col-1">
              <i class="orange-icon fal fa-address-book" />
            </div>

            <div class="col-10 d-flex flex-column">
              <label>Estudiante:</label>
              <span>
                {{ information.studentSie }} -
                {{ information.studentName }}
              </span>
            </div>
          </div>
        </template>

        <template v-if="isTwoOrMoreStudents">
          <div class="row">
            <div class="col-1">
              <i class="orange-icon fas fa-map" />
            </div>
            <div class="col-10 d-flex flex-column">
              <label>Centro:</label>
              <span class="text-capitalize">
                {{
                  information.centerName
                    ? information.centerName.toLowerCase()
                    : ""
                }}
              </span>
            </div>
          </div>
        </template>

        <template v-if="isGroup">
          <div class="row">
            <div class="col-1">
              <i class="orange-icon fas fa-map" />
            </div>
            <div class="col-10 d-flex flex-column">
              <label>Municipio:</label>
              <span class="text-capitalize">
                {{
                  information.municipalityName
                    ? information.municipalityName.toLowerCase()
                    : ""
                }}
              </span>
            </div>
          </div>
        </template>
      </div>

      <!-- col 4 -->
      <div class="col-12 col-md pb-3 pb-md-0">
        <template v-if="isOneStudent">
          <div class="row">
            <div class="col-1">
              <i class="orange-icon fal fa-calendar-edit" />
            </div>

            <div class="col-10 d-flex flex-column">
              <label>Edad:</label>
              <span>{{ information.studentAge }} años</span>
            </div>
          </div>
        </template>

        <template v-if="isTwoOrMoreStudents">
          <div class="row">
            <div class="col-1">
              <i class="orange-icon fas fa-map" />
            </div>
            <div class="col-10 d-flex flex-column">
              <label>Municipio:</label>
              <span class="text-capitalize">
                {{
                  information.municipalityName
                    ? information.municipalityName.toLowerCase()
                    : ""
                }}
              </span>
            </div>
          </div>
        </template>

        <template v-if="isGroup">
          <div class="row">
            <div class="col-1">
              <i class="orange-icon fas fa-school" />
            </div>
            <div class="col-10 d-flex flex-column">
              <label>Escuela:</label>
              <span class="text-capitalize">
                {{
                  information.schoolName
                    ? information.schoolName.toLowerCase()
                    : ""
                }}
              </span>
            </div>
          </div>
        </template>
      </div>

      <!-- col 5 -->
      <div class="col-12 col-md pb-1 pb-md-0">
        <template v-if="isOneStudent">
          <div class="row">
            <div class="col-1">
              <i class="orange-icon fal fa-clipboard-list-check" />
            </div>

            <div class="col-10 d-flex flex-column">
              <label>Impedimento:</label>
              <span class="text-capitalize">
                {{
                  information.studentImpediment
                    ? information.studentImpediment.toLowerCase()
                    : ""
                }}
              </span>
            </div>
          </div>
        </template>

        <template v-if="isTwoOrMoreStudents">
          <div class="row">
            <div class="col-1">
              <i class="orange-icon fas fa-school" />
            </div>
            <div class="col-10 d-flex flex-column">
              <label>Escuela:</label>
              <span class="text-capitalize">
                {{
                  information.schoolName
                    ? information.schoolName.toLowerCase()
                    : ""
                }}
              </span>
            </div>
          </div>
        </template>

        <template v-if="isGroup">
          <div class="row">
            <div class="col-1">
              <i class="orange-icon fal fa-address-book" />
            </div>
            <div class="col-10 d-flex flex-column">
              <label>Nombre del Maestro:</label>
              <span class="text-capitalize">
                {{
                  information.teacherName
                    ? information.teacherName.toLowerCase()
                    : ""
                }}
              </span>
            </div>
          </div>
        </template>
      </div>
    </div>
    <slot name="sub-board" />
  </div>
</template>

<script>
import {requestTypeCodes} from "@/utils/constants/hrrequest/requestTypeCodes";
import { requestStatusString } from "@/utils/constants/hrrequest/requestStatusCodes";
import { getInformationHeader } from "@/modules/human-resources/api";

export default {
  name: "InformationHeader",
  components: {},
  props: {
    requestId: {
      type: Number,
      default: () => null,
      required: true
    },
    assistantTypeId: {
      type: [Number, String],
      default: () => null,
      required: true
    },
    statusId: {
      type: [Number, String],
      default: () => null,
      required: true
    },
    getInformationHeader: {
      type: Function,
      default: getInformationHeader,
      required: false
    },
    requestStatusString: {
      type: Object,
      default: () => requestStatusString,
      required: false
    }
  },
  computed: {
    isOneStudent() {
      return this.assistantTypeId == requestTypeCodes.Estudiantes;
    },
    isTwoOrMoreStudents() {
      return this.assistantTypeId == requestTypeCodes.DosMasEstudiantes;
    },
    isGroup() {
      return this.assistantTypeId == requestTypeCodes.Grupo;
    },
    getRequestStatus() {
      return (
        this.requestStatusString[this.statusId] ||
        this.information.hrRequestStatus
      );
    },
    getRequestNumber() {
      return this.information.requestNumber ?? "-";
    }
  },
  data() {
    return {
      information: {
        peiId: "",
        hrRequestStatus: "",
        studentSie: "",
        studentName: "",
        studentAge: "",
        municipalityName: "",
        regionName: "",
        centerName: "",
        schoolName: "",
        studentImpediment: "",
        teacherName: "",
        requestNumber: ""
      }
    };
  },
  methods: {
    formatPeiNumber(peiId) {
      if (peiId) {
        const year = peiId.slice(0, 4);
        const id = peiId.slice(4);

        return `${year}-${id}`;
      }

      return "-";
    },
    async getInformation() {
      const { data } = await this.getInformationHeader(this.requestId);
      this.information = data;
      this.$emit("update:information-header", this.information);
    }
  },
  mounted() {
    this.getInformation();
  }
};
</script>

<style scoped>
.orange-icon {
  color: #ff7058 !important;
  font-weight: bold;
  font-size: 18px;
}

.light-gray-container {
  background: #f2f2f2;
  border-radius: 5px;
  padding: 10px 25px;
}

.white-container {
  background: #fff;
  border-radius: 5px;
  padding: 10px 20px;
}

.white-container label {
  font-size: 14px;
  color: #727272;
}

.white-container span {
  font-size: 16px;
  font-weight: normal;
  color: #11291b;
}

@media screen and (max-width: 480px) {
  .white-container {
    padding: 20px 10px;
  }

  .white-container label {
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 0;
  }

  .white-container span {
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
  }
}
</style>
